export default __webpack_public_path__ + "static/media/Connect.fb6b74ea.png";